import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from '@/components/layout/Header';
import { LocalizedLink } from '@/components/LocalizedLink';
import { SEO } from '@/components/SEO';

const NotFound = () => {
  const { t } = useTranslation(['notFound', 'seo', 'common']);
  const headingRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <main id="main-content" className="flex min-h-screen flex-col bg-background">
      <SEO
        title={t('seo:notFound.title')}
        description={t('seo:notFound.description')}
        keywords={t('seo:notFound.keywords')}
        logicalPath="/404"
      />
      <Header />
      <div className="flex flex-1 flex-col items-center justify-center px-6">
        <h1
          ref={headingRef}
          tabIndex={-1}
          className="mb-4 text-6xl font-bold text-foreground outline-none"
        >
          {t('notFound:title')}
        </h1>
        <p className="mb-8 text-xl text-muted-foreground">{t('notFound:message')}</p>
        <LocalizedLink
          href="/"
          className="focus-ring rounded-sm text-primary underline hover:text-primary/80"
        >
          {t('common:cta.returnHome')}
        </LocalizedLink>
      </div>
    </main>
  );
};

export default NotFound;
